import {
  ManageUsersData,
  TableCellAttribute,
  TableCellStyles,
  TableDataAdaptee,
  TableHeadData,
  TableRowData,
} from 'src/app/interfaces/tables.interfaces';
import { UserBasic } from 'src/app/swagger-api';
import { defaultMemberTableHead, manageUsersTableRowData, membersTableCellAttributes } from '../table-users-list.data';
import { tableComponentStyles } from './table.styles';

export class NoManageTableDataAdaptee implements TableDataAdaptee {
  public constructor(private dictionary: ManageUsersData) {}

  public getTableHeadData(): TableHeadData[] {
    return defaultMemberTableHead;
  }

  public getCellAttributes(): TableCellAttribute[] {
    return membersTableCellAttributes;
  }

  public getCellStyles(): TableCellStyles {
    return tableComponentStyles.members;
  }

  public createTableBody(): TableRowData[] {
    return this.dictionary.users.map((user: UserBasic, id: number) =>
      manageUsersTableRowData(id, user, this.dictionary.entity),
    );
  }
}
